<div *ngIf="!authService.adminLogin.email; else adminNavbar">
    <app-admin-login></app-admin-login>
</div>

<ng-template #adminNavbar>
    <div class="admin-container">

        <!-- Sidebar -->
        <nav class="sidebar">

            <button class="menu-btn" routerLink="submit" routerLinkActive="active">Submit</button>
            <button class="menu-btn" routerLink="names" routerLinkActive="active">Names</button>
            <button class="menu-btn" routerLink="emails" routerLinkActive="active">Emails</button>
            <button class="menu-btn" routerLink="weekly" routerLinkActive="active">Weekly</button>
            <button class="menu-btn" routerLink="urgent" routerLinkActive="active">Urgent</button>
            <button class="menu-btn" routerLink="settings" routerLinkActive="active">Settings</button>

        </nav>

        <!-- Main content -->
        <main class="content">
            <router-outlet (activate)="changeOfRoutes()"></router-outlet>
        </main>

    </div>
</ng-template>
